import { useMemo } from "react";
import styles from "./SizeMediumStateDefaultSt.module.css";

const SizeMediumStateDefaultSt = ({
  linkText,
  sizeMediumStateDefaultStCursor,
  sizeMediumStateDefaultStBorder,
  resumeDisplay,
}) => {
  const sizeMediumStateDefaultStStyle = useMemo(() => {
    return {
      cursor: sizeMediumStateDefaultStCursor,
      border: sizeMediumStateDefaultStBorder,
    };
  }, [sizeMediumStateDefaultStCursor, sizeMediumStateDefaultStBorder]);

  const resumeStyle = useMemo(() => {
    return {
      display: resumeDisplay,
    };
  }, [resumeDisplay]);

  return (
    <div
      className={styles.sizemediumStatedefaultSt}
      style={sizeMediumStateDefaultStStyle}
    >
      <div className={styles.resume} style={resumeStyle}>
        {linkText}
      </div>
    </div>
  );
};

export default SizeMediumStateDefaultSt;
